export const config = {
    logOutTime: true,
    czasSesji: 20
}